import { useMemo, useState } from "react";

export default function useModalState<T>(): ModalState<T> {
    const [state, setState] = useState<{ show: boolean, data?: T }>({ show: false });

    return useMemo(() => ({
        isShowing: state.show,
        data: state.data,
        show: data => setState({ show: true, data }),
        hide: () => setState({ show: false }),
        setData: data => setState(m => ({ ...m, data }))
    }), [state])
}

export interface ModalState<T> {
    isShowing: boolean;
    data?: T;
    show(data?: T): void;
    hide(): void;
    setData(data: T): void;
}